import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
//import createPersistedState from "vuex-persistedstate";
import events from "./modules/events";
import groups from "./modules/groups";
import users from "./modules/users";
import login from "./modules/login";
import chat from "./modules/chat";
import services from "./modules/services";
import notifications from "./modules/notifications";
import commissions from "./modules/commissions";
import payments from "./modules/payments";
import orders from "./modules/orders";
import alerts from "./modules/alerts";
import logs from "./modules/logs";
import parameters from "./modules/parameters";
import ratings from "./modules/ratings";
import components from "./modules/components";
import actions from "./actions";
import tasks from "./modules/tasks";
import reports from "./modules/reports";
import process from "./modules/process";
import news from "./modules/news";
import dod from "./modules/dod";
import leftBarElements from "./modules/leftBarElements";
import dodCustomers from "./modules/dodCustomers";
import dodEmployees from "./modules/dodEmployees";
import dodTasks from "./modules/dodTasks"
import dodSms from "./modules/dodSms"
import dodSettings from "./modules/dodSettings"
import dodUsers from "./modules/dodUsers";
import dodAdmins from "./modules/dodAdmins";
import dodOrders from "./modules/dodOrders"
import dodSettlements from "./modules/dodSettlements";
import dodReportArchive from "./modules/dodReportArchive";
export default new Vuex.Store({
  //plugins: [createPersistedState()],
  actions,
  modules: {
    login,
    groups,
    events,
    users,
    chat,
    services,
    notifications,
    commissions,
    payments,
    orders,
    alerts,
    logs,
    parameters,
    ratings,
    components,
    tasks,
    reports,
    process,
    news,
    dod,
    leftBarElements,
    dodCustomers,
    dodEmployees,
    dodTasks,
    dodSms,
    dodSettings,
    dodUsers,
    dodAdmins,
    dodOrders,
    dodSettlements,
    dodReportArchive
  },
});
